import {
	getAction
} from '@/api/index';
export default {
	data() {
		return {
			url: {
				listProject: '/officialWebsite/c-api/project/list',
				listProduct: '/officialWebsite/c-api/product/list',
				listTec: "/officialWebsite/c-api/coreTechnology/list",
				parkAreaSetting: '/officialWebsite/c-api/setting/parkArea'
			},
			dataList: [],
			curData: {}
		}
	},
	computed: {
		recType() {
			return this.$route.query.type;
		},
		recId() {
			return this.$route.query.id;
		}
	},
	watch: {
		recType: {
			handler(val, oldValue) {
				if(val) {
					this.loadData();
				}
			}
		},
		recId: {
			handler(val, oldValue) {
				this.setCurData();
			},
			//立刻执行handler
			//immediate: true
		},
		scaleRate: {
			handler(val, oldValue) {
				this.calcContentHeight();
			},
			//立刻执行handler
			//immediate: true
		}
	},
	mounted() {
		this.loadData();
	},
	methods: {
		async loadData() {
			if(this.recType == 'project') {
				await this.loadProjects();
			}else if(this.recType == 'product') {
				await this.loadProducts();
			}else if(this.recType == 'tec') {
				await this.loadTecs();
			}else if(this.recType == 'aboutMe') {
				await this.loadParkArea();
			}
			this.setCurData();
		},
		setCurData() {
			this.curData = this.dataList.filter(it => it.id == this.recId)[0];
			setTimeout(() => {
				this.calcContentHeight();
			}, 100);
		},
		async loadProjects() {
			const res = await getAction(this.url.listProject);
			if (res.success) {
				this.dataList = res.result.map(it => {
					return {
						id: it.id,
						title: it.projectName,
						content: it.projectDescribe,
						tag1: it.projectLocation.type == 0 
							? it.projectLocation.provinceTxt : it.countryInf.countryChinese,
						tag2: it.projectLocation.type == 0 ? it.projectLocation.cityTxt : ''
					}
				});
			}
		},
		async loadProducts() {
			const res = await getAction(this.url.listProduct);
			if (res.success) {
				let lst = res.result;
				const rec = lst.filter(it => it.id == this.recId)[0];
				this.dataList = lst.filter(it => it.categoryIds == rec.categoryIds).map(it => {
					return {
						id: it.id,
						title: it.productName,
						content: it.productDescribe,
						tag1: '',
						tag2: ''
					}
				});
			}
		},
		async loadTecs() {
			const res = await getAction(this.url.listTec);
			if (res.success) {
				this.dataList = res.result.map(it => {
					return {
						id: it.id,
						title: it.technicalName,
						content: it.technicalDescribe,
						tag1: '',
						tag2: ''
					}
				});
			}
		},
		async loadParkArea() {
			const res = await getAction(this.url.parkAreaSetting);
			if (res.success) {
				this.dataList = res.result.itemSettings.filter(it => it.jumpType == 0 && it.innerContent)
					.sort((a,b) => a.sortNo - b.sortNo).map(it => {
					return {
						id: it.itemIdx,
						title: it.promptText,
						content: it.innerContent
					}
				});
			}
		},
		onClickItem(item) {
			this.$router.push({
				path: '/detail?type='+this.recType+'&id=' + item.id
			});
		},
		calcContentHeight() {
			this.$nextTick(() => {
				let doms = document.getElementsByClassName('auto-height');
				for (let i = 0; i < doms.length; i++) {
					doms[i].style.height =
						(doms[i].getElementsByClassName('calc-line')[0].getBoundingClientRect().height) + 'px';
				}
			});
		},
	}
}